import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../common/Modal';
import { t } from '../../../../../../modules/infra/i18n';

const ConfirmationModal = ({ close, confirm, submitting }) => (
  <Modal title={t('customers:duplicates.merge_modal_title')} close={close} showCloseButton>
    <div className="c-modal__text u-max-width-530 u-pv u-margin-auto u-fontsize-medium">
      {t('customers:duplicates.merge_confirmation_message')}
    </div>
    <div className="u-text-right u-m">
      <button
        type="button"
        className="c-btn c-btn--grey u-width-120 u-mr"
        onClick={close}
        disabled={submitting}
      >
        {t('customers:duplicates.no_button')}
      </button>
      <button
        type="button"
        className="c-btn u-width-120"
        onClick={confirm}
        disabled={submitting}
      >
        {t('customers:duplicates.yes_button')}
      </button>
    </div>
  </Modal>
);

ConfirmationModal.propTypes = {
  close: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default ConfirmationModal;
